import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';

// https://github.com/akveo/ng2-smart-table/blob/master/src/app/pages/examples/custom-edit-view/basic-example-button-view.component.ts
// https://github.com/akveo/ng2-smart-table/issues/401
// https://github.com/akveo/ng2-smart-table/issues/533
@Component({
  selector: 'crypto-button-view',
  template: `
    <button
      type="button"
      class="btn btn-success"
      style="padding:2px 10px 2px 10px;"
      [disabled]="disabled"
      (click)="onClick()">{{ renderValue }}<i *ngIf="renderIcon" class="{{renderIcon}}"></i></button>
  `,
})
export class ButtonViewComponent implements ViewCell, OnInit {
  renderValue: string;
  renderIcon: string;

  @Input() value: string | number;
  @Input() rowData: any;
  @Input() disabled: boolean = false;

  @Output() save: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
    // this.renderValue = this.value.toString().toUpperCase();
    // console.log('value=' + JSON.stringify(this.value));
    // console.log('rowData=' + JSON.stringify(this.rowData));
  }

  onClick() {
    this.save.emit(this.rowData);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages-crypto/renderer-crypto/button-renderer-crypto.ts